import { encode } from 'base-64';
export const svgToUri = (svg: string): string => {
  const base64Svg = encode(svg);
  return `data:image/svg+xml;base64,${base64Svg}`;
};
